import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import { eventsQueryAgg } from '@/graphql/queries/event'
import { GC_USER_ID } from '@/constants'
import Loading from '../modals/Loading'
import { OrdinalFrame } from 'semiotic'
import * as moment from 'moment'
import * as Alasql from 'alasql'
import { GridList, GridListTile } from 'material-ui'
import '../modals/modal.css'

const generate = (n, x) => {
  var arr = []
  for (var i = 0; i < n; i++) {
    arr.push(i * x)
  }
  return arr
}

@graphql(eventsQueryAgg, {
  name: 'eventsQueryAgg',
  options: ownProps => ({
    variables: {
      userId: global.localStorage.getItem(GC_USER_ID),
      dayS: ownProps.dayS,
      dayE: ownProps.dayE
    },
    refetchQueries: ['eventsQueryAgg']
  })
})
export default class AlchemyTimelineMonthly extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  addBlankDate = data => {
    var iDateStart = moment(new Date(this.props.dayS)).startOf('month')
    var iDateEnd = moment(new Date(this.props.dayS)).endOf('month')
    var daysDif = iDateEnd.diff(iDateStart, 'days') + 1

    for (var i = 0; i < daysDif; i++) {
      var blankDate = iDateStart
      var isSame = false

      for (var j in data) {
        if (
          moment(new Date(data[j].date)).format('l') === blankDate.format('l')
        ) {
          isSame = true
        }
      }
      if (!isSame) {
        data.splice(i, 0, {
          date: blankDate.format('l'),
          minutes: 0,
          type: 'blank'
        })
        isSame = false
      }

      iDateStart = moment(blankDate).add(1, 'd')
    }

    return data
  }

  getPivotArrayResult(dataArray, rowIndex, colIndex, dataIndex) {
    //Code from https://techbrij.com
    var result = {}
    for (var i = 0; i < dataArray.length; i++) {
      if (!result[dataArray[i][rowIndex]]) {
        result[dataArray[i][rowIndex]] = []
      }
      if (dataIndex === '') {
        result[dataArray[i][rowIndex]][dataArray[i][colIndex]] = dataArray[i]
      } else {
        result[dataArray[i][rowIndex]].push({
          cat: dataArray[i][colIndex],
          color:
            dataArray[i][colIndex] === 'Very Productive'
              ? 'rgba(147, 112, 219,0.6)'
              : dataArray[i][colIndex] === 'Productive'
                ? 'rgba(100,149,237,0.3)'
                : dataArray[i][colIndex] === 'Maintenance'
                  ? 'rgba(160,82,45,0.4)'
                  : dataArray[i][colIndex] === 'Distracting'
                    ? 'rgba(255,105,180,0.6)'
                    : dataArray[i][colIndex] === 'Very Distracting'
                      ? 'rgba(255,0,0,0.4)'
                      : 'rgba(128,128,128,0.4)',
          minutes: dataArray[i][dataIndex],
          date: dataArray[i][rowIndex]
        })
      }
    }
    return result
  }

  render() {
    if (this.props.eventsQueryAgg.loading) {
      return <Loading />
    }
    var events = []
    if (this.props.eventsQueryAgg.allEvents) {
      this.props.eventsQueryAgg.allEvents.map(e =>
        events.push({
          id: e.id,
          date: moment(new Date(e.completedAt)).format('L'),
          tid: e.tracker.id,
          name: e.tracker.name,
          cat: e.tracker.category,
          color: e.tracker.color,
          minutes: e.minutes
        })
      )
    }
    var eventsByCat = Alasql(
      'SELECT cat, color, date, SUM(CAST([minutes] AS INT)) AS [minutes]  FROM ? GROUP BY cat, color, date',
      [events]
    )
    var eventsByCatPie = Alasql(
      'SELECT cat, date, SUM(CAST([minutes] AS INT)) AS [minutes]  FROM ? GROUP BY cat, date ORDER BY CASE WHEN cat = "Very Productive" THEN "1" WHEN cat = "Productive" THEN "2" WHEN cat = "Maintenance" THEN "3" WHEN cat = "Distracting" THEN "4" WHEN cat = "Very Distracting" THEN "5" ELSE cat END ASC, convert(datetime, date, 101) ASC',
      [events]
    )
    var es = this.getPivotArrayResult(eventsByCatPie, 'date', 'cat', 'minutes')
    const keys = Object.keys(es)
    var ess = []
    keys.forEach(key => {
      const e = es[key]
      var offTrackMinsHappenedCat =
        24 * 60 -
        e.reduce(function(cnt, o) {
          return cnt + o.minutes
        }, 0)

      if (offTrackMinsHappenedCat > 0) {
        e.push({
          cat: 'no tracking',
          color: 'white',
          date: e[0].date,
          minutes: offTrackMinsHappenedCat
        })
      }
      ess.push(e)
    })

    var eventsKPIVP = eventsByCat.filter(e => e.cat === 'Very Productive')
    eventsKPIVP = this.addBlankDate(eventsKPIVP)
    var eventsKPIP = eventsByCat.filter(e => e.cat === 'Productive')
    eventsKPIP = this.addBlankDate(eventsKPIP)
    var eventsKPIVD = eventsByCat.filter(e => e.cat === 'Very Distracting')
    eventsKPIVD = this.addBlankDate(eventsKPIVD)
    var eventsKPIO = eventsByCat.filter(
      e =>
        e.cat !== 'Very Productive' &&
        e.cat !== 'Productive' &&
        e.cat !== 'Very Distracting'
    )
    eventsKPIO = this.addBlankDate(eventsKPIO)

    return (
      <div>
        <div style={{ margin: 10 }}>
          <GridList className="gridList" cols={7}>
            {ess &&
              ess.map((e, index) => (
                <GridListTile
                  xs={6}
                  cols={1}
                  key={index}
                  style={{ width: 44, height: 44 }}
                >
                  <OrdinalFrame
                    /* --- Data --- */
                    data={e}
                    /* --- Size --- */
                    size={[40, 40]}
                    margin={2}
                    /* --- Layout --- */
                    type="bar"
                    projection="radial"
                    dynamicColumnWidth={'minutes'}
                    /* --- Process --- */
                    oAccessor="cat"
                    /* --- Customize --- */
                    style={d => ({
                      fill: d.color,
                      stroke: d.cat === 'no tracking' ? 'lightgrey' : 'white'
                    })}
                    title={
                      moment(new Date(e[0].date)).format('D') +
                      (moment(new Date(e[0].date)).day() === 0
                        ? 'S'
                        : moment(new Date(e[0].date)).day() === 1
                          ? 'M'
                          : moment(new Date(e[0].date)).day() === 2
                            ? 'T'
                            : moment(new Date(e[0].date)).day() === 3
                              ? 'W'
                              : moment(new Date(e[0].date)).day() === 4
                                ? 'T'
                                : moment(new Date(e[0].date)).day() === 5
                                  ? 'F'
                                  : 'S')
                    }
                    oLabel={false}
                  />
                </GridListTile>
              ))}
          </GridList>
        </div>
        <div
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <OrdinalFrame
            data={eventsKPIVP}
            size={[this.props.width / 1.28, this.props.height / 1.28]}
            type="bar"
            oAccessor={d => moment(new Date(d.date)).date()}
            sortO={(a, b) => a > b}
            rAccessor="minutes"
            style={d => ({ fill: d.color, stroke: 'white' })}
            axis={[
              {
                orient: 'left',
                tickFormat: d => (
                  <text
                    key={`tick-${d}`}
                    style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
                    y={-2}
                  >
                    {d / 60 + 'h'}
                  </text>
                ),
                tickValues: generate(24, 60),
                baseline: false,
                tickLineGenerator: ({ xy }) => (
                  <path
                    key={`tickLine-${xy.value}`}
                    style={{ stroke: '#F0F0F0 ' }}
                    d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${
                      xy.y1
                    }L${xy.x1},${xy.y1}Z`}
                  />
                )
              }
            ]}
            margin={{
              left: this.props.width / 7.5,
              top: this.props.height / 24,
              right: this.props.width / 10.6,
              bottom: this.props.height / 9.6
            }}
            oLabel={d => (
              <text
                key={`label-${d}`}
                fill="#cecece"
                textAnchor="middle"
                fontSize={14}
              >
                {d}
              </text>
            )}
          />
        </div>
        <div
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <OrdinalFrame
            data={eventsKPIVD}
            size={[this.props.width / 1.28, this.props.height / 1.28]}
            type="bar"
            oAccessor={d => moment(new Date(d.date)).date()}
            sortO={(a, b) => a > b}
            rAccessor="minutes"
            style={d => ({ fill: d.color, stroke: 'white' })}
            axis={[
              {
                orient: 'left',
                tickFormat: d => (
                  <text
                    key={`tick-${d}`}
                    style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
                    y={-2}
                  >
                    {d / 60 + 'h'}
                  </text>
                ),
                tickValues: generate(24, 60),
                baseline: false,
                tickLineGenerator: ({ xy }) => (
                  <path
                    key={`tickLine-${xy.value}`}
                    style={{ stroke: '#F0F0F0 ' }}
                    d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${
                      xy.y1
                    }L${xy.x1},${xy.y1}Z`}
                  />
                )
              }
            ]}
            margin={{
              left: this.props.width / 7.5,
              top: this.props.height / 24,
              right: this.props.width / 10.6,
              bottom: this.props.height / 9.6
            }}
            oLabel={d => (
              <text
                key={`label-${d}`}
                fill="#cecece"
                textAnchor="middle"
                fontSize={14}
              >
                {d}
              </text>
            )}
          />
        </div>
        <div
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <OrdinalFrame
            data={eventsKPIP}
            size={[this.props.width / 1.28, this.props.height / 1.28]}
            type="bar"
            oAccessor={d => moment(new Date(d.date)).date()}
            sortO={(a, b) => a > b}
            rAccessor="minutes"
            style={d => ({ fill: d.color, stroke: 'white' })}
            axis={[
              {
                orient: 'left',
                tickFormat: d => (
                  <text
                    key={`tick-${d}`}
                    style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
                    y={-2}
                  >
                    {d / 60 + 'h'}
                  </text>
                ),
                tickValues: generate(24, 60),
                baseline: false,
                tickLineGenerator: ({ xy }) => (
                  <path
                    key={`tickLine-${xy.value}`}
                    style={{ stroke: '#F0F0F0 ' }}
                    d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${
                      xy.y1
                    }L${xy.x1},${xy.y1}Z`}
                  />
                )
              }
            ]}
            margin={{
              left: this.props.width / 7.5,
              top: this.props.height / 24,
              right: this.props.width / 10.6,
              bottom: this.props.height / 9.6
            }}
            oLabel={d => (
              <text
                key={`label-${d}`}
                fill="#cecece"
                textAnchor="middle"
                fontSize={14}
              >
                {d}
              </text>
            )}
          />
        </div>
        <div
          style={{
            position: 'relative',
            textAlign: 'center',
            marginLeft:
              -this.props.width * 0.07 +
              (window.innerWidth - this.props.width / 1.28) / 2
          }}
        >
          <OrdinalFrame
            data={eventsKPIO}
            size={[this.props.width / 1.28, this.props.height / 1.28]}
            type="bar"
            oAccessor={d => moment(new Date(d.date)).date()}
            sortO={(a, b) => a > b}
            rAccessor="minutes"
            style={d => ({ fill: d.color, stroke: 'white' })}
            axis={[
              {
                orient: 'left',
                tickFormat: d => (
                  <text
                    key={`tick-${d}`}
                    style={{ fill: '#cecece', textAnchor: 'end', fontSize: 10 }}
                    y={-2}
                  >
                    {d / 60 + 'h'}
                  </text>
                ),
                tickValues: generate(24, 60),
                baseline: false,
                tickLineGenerator: ({ xy }) => (
                  <path
                    key={`tickLine-${xy.value}`}
                    style={{ stroke: '#F0F0F0 ' }}
                    d={`M${xy.x1},${xy.y1}L${xy.x2},${xy.y1}L${xy.x2},${
                      xy.y1
                    }L${xy.x1},${xy.y1}Z`}
                  />
                )
              }
            ]}
            margin={{
              left: this.props.width / 7.5,
              top: this.props.height / 24,
              right: this.props.width / 10.6,
              bottom: this.props.height / 9.6
            }}
            oLabel={d => (
              <text
                key={`label-${d}`}
                fill="#cecece"
                textAnchor="middle"
                fontSize={14}
              >
                {d}
              </text>
            )}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyTimelineMonthly.js